module.exports = __webpack_public_path__ + "static/netflix-estacao-1-5442984a9ce4b72bd36bdfb1e12e4ce9.jpg";